import Modal from "react-modal";
import { Button } from "@aidron/aidron-ds";

export const UnsavedItemsWarningModal = ({ ctx, uiState, actions }) => {

  const { unsavedItems } = ctx || {};
  const { showUnsavedWarningModal } = uiState || {};
  const { setShowUnsavedItemsModal } = actions || {};

  const message = unsavedItems?.length === 1
    ? `O produto "${unsavedItems[0].productName}" foi adicionado, mas não salvo; logo, o valor de compra final é zero. Edite-o e salve-o para que integre o pedido de forma oficial.`
    : `${unsavedItems?.length} produtos foram adicionados, mas não salvos; logo, o valor de compra final é zero. Edite-os e salve-os para que integrem o pedido de forma oficial.`;

  return (
    <Modal
      isOpen={showUnsavedWarningModal}
      onRequestClose={() => setShowUnsavedItemsModal(false)}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 20000,
        },
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          padding: "2rem",
          borderRadius: "8px",
          width: "480px",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",
        },
      }}
      contentLabel="Atenção"
    >
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
        <hgroup>
          <h2 style={{ margin: 0, fontSize: "1.2rem", fontFamily: "Lato, sans-serif" }}>
            <strong>Produto não salvo</strong>
          </h2>
          <p style={{ color: 'rgb(100, 116, 139)', fontSize: '0.875rem' }}>
            {message}
          </p>
        </hgroup>

        <button
          onClick={() => setShowUnsavedItemsModal(false)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "1.2rem",
            color: "#626772",
          }}
        >
          ✕
        </button>
      </div>

      {/* Lista de itens não salvos */}
      {unsavedItems?.map(item => (
        <div
          key={item.productId}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "12px 16px",
            borderBottom: "1px solid #f0f2f4",
            backgroundColor: "#FFF5EC",
            borderRadius: "6px",
          }}
        >
          <div style={{ flex: 1 }}>
            <p style={{
              margin: 0,
              fontSize: "14px",
              fontWeight: "700",
              fontFamily: "Lato, sans-serif",
              color: "#2c2c2a",
            }}>
              {item.productName}
            </p>
            <p style={{
              margin: 0,
              fontSize: "12px",
              fontFamily: "Lato, sans-serif",
              color: "#888780",
            }}>
              SKU {item.sku} · {item.productSubgroupName}
            </p>
          </div>

          <span style={{
            padding: "0.2rem 0.4rem",
            backgroundColor: "#FFF5EC",
            color: "#e75d0d",
            fontSize: "0.6rem",
            fontWeight: "700",
            borderRadius: "9999px",
            fontFamily: "Lato, sans-serif",
            border: "1px solid #e75d0d",
          }}>
            não salvo
          </span>
        </div>
      ))}

      {/* Ação */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          label="Entendi"
          type="filled"
          size="sm"
          onClick={() => setShowUnsavedItemsModal(false)}
        />
      </div>
    </Modal>
  );
};